import { translationContext } from "@/States/translationContext";

import { Trans, TransProps, useTranslation } from "react-i18next";

import type { DefaultNamespace } from "i18next";

export const Translate: React.FC<
  TransProps<string, DefaultNamespace, undefined, string | undefined>
> = (props) => {
  const { t } = useTranslation();
  const { context } = translationContext.getState();
  return <Trans tOptions={{ context }} {...props} t={t}></Trans>;
};
